import React from "react";

import { Weather } from "../features/weather";

const WeatherPage = () => {
  return <Weather />;
};

export default WeatherPage;
